import { Component, ComponentFactoryResolver, Injector, AfterViewInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { TimekitOptionsComponent } from '../timekit-options/timekit-options.component';
import { TimekitSessionsComponent } from '../timekit-sessions/timekit-sessions.component';
import { TimekitCreateProjectComponent } from '../timekit-create-project/timekit-create-project.component';
import { TimekitProjectsComponent } from '../timekit-projects/timekit-projects.component';
import { TimekitScheduleComponent } from '../timekit-schedule/timekit-schedule.component';

import { TranslateService } from '@ngx-translate/core';

export interface ITimekitComponent {
  data: any;
}

@Component({
  selector: 'app-timekit-tabs',
  templateUrl: './timekit-tabs.component.html',
  styleUrls: ['./timekit-tabs.component.scss'],
})
export class TimekitTabsComponent implements AfterViewInit {
  @ViewChild('tabContent', { read: ViewContainerRef }) container!: ViewContainerRef;

  activeTab: number = 0;

  tabs: { title: string; component: Type<ITimekitComponent>; data: any }[] = [
    { title: '', component: TimekitScheduleComponent, data: '' },
    { title: '', component: TimekitOptionsComponent, data: '' },
    { title: '', component: TimekitSessionsComponent, data: '' }
  ];

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    (window as any).timekitTabs = this;
    this.translate.stream([
      'APPOINTMENT',
      'CONFIGURATION',
      'SESSIONS'
    ]).subscribe(translations => {
      this.tabs = [
        { title: translations['APPOINTMENT'], component: TimekitScheduleComponent, data: '' },
        { title: translations['CONFIGURATION'], component: TimekitOptionsComponent, data: '' },
        { title: translations['SESSIONS'], component: TimekitSessionsComponent, data: '' },
        { title: translations['PROJECTS'], component: TimekitProjectsComponent, data: '' },
        { title: translations['CREATE_PROJECT'], component: TimekitCreateProjectComponent, data: null }
      ];
    });
  }

  ngAfterViewInit(): void {
    this.loadComponent();
  }

  setActiveTab(index: number): void {
    this.activeTab = index;
    this.loadComponent();
  }

  private loadComponent(): void {
    const tab = this.tabs[this.activeTab];
    this.container.clear();

    const factory = this.componentFactoryResolver.resolveComponentFactory(tab.component);
    const componentRef = this.container.createComponent(factory, 0, this.injector);

    // Asigna datos al componente (si el componente los recibe a través de una propiedad)
    (componentRef.instance as ITimekitComponent).data = tab.data;
  }

  refreshProjectListing(): void {
    const listingTabIndex = this.tabs.findIndex(t => t.component === TimekitProjectsComponent);
    this.tabs[listingTabIndex].data = {};
    this.setActiveTab(listingTabIndex);
  }

  setCreateProjectTab(externalId: string | null = null): void {
    const createProjectTabIndex = this.tabs.findIndex(t => t.component === TimekitCreateProjectComponent);
    this.tabs[createProjectTabIndex].data = externalId;
    this.setActiveTab(createProjectTabIndex);
  }
}
